import {
  WSInfiniteScroll,
  WSLoader,
  WSPage,
  WSPageToolbar,
  WSText
} from "@wingspanhq/fe-component-library";
import { FrequencyAndScheduleStatus } from "@wingspanhq/payments/dist/interfaces";
import { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { INVOICING_PATH } from "..";
import { useBrowserPageTitle } from "../../../shared/hooks/useBrowserPageTitle";
import { useUrlQueryFilters } from "../../../utils/router";
import { TableInvoiceTemplates } from "../components/TableInvoiceTemplates";
import { Filters, Toolbar } from "../components/Toolbar";
import { useQueryInvoiceTemplateRows } from "../queries/useQueryInvoiceTemplateRows";
import { useQueryInvoiceTemplateRowsSummary } from "../queries/useQueryInvoiceTemplateRowsSummary";

export const RouteScheduled: React.FC = () => {
  useBrowserPageTitle("Scheduled invoices");
  const history = useHistory();
  const { defaultFilters, filters, setFilters } = useUrlQueryFilters<Filters>({
    memberClientId: "all"
  });

  const requestFilters = useMemo(
    () => ({
      "invoiceData.memberClientId":
        filters.memberClientId === "all" ? undefined : filters.memberClientId,
      status: {
        in: [
          FrequencyAndScheduleStatus.Active,
          FrequencyAndScheduleStatus.Draft
        ]
      }
    }),
    [filters.memberClientId]
  );

  const queryRows = useQueryInvoiceTemplateRows({
    filter: requestFilters
  });
  const querySummary = useQueryInvoiceTemplateRowsSummary({
    filter: requestFilters
  });

  return (
    <WSPage>
      <WSPageToolbar
        breadcrumbs={[
          {
            label: "Invoicing",
            onClick: () => {
              history.push(INVOICING_PATH);
            }
          },
          {
            label: "Scheduled"
          }
        ]}
        title="Scheduled invoices"
        actions={[
          {
            label: "Search",
            icon: "search",
            buttonKind: "Tertiary",
            onClick: () => history.push(`${INVOICING_PATH}/search`),
            hideButtonOn: false
          },
          {
            label: "Create invoice",
            icon: "plus",
            buttonKind: "Primary",
            onClick: () => history.push(INVOICING_PATH + "/create")
          }
        ]}
      />

      <Toolbar
        defaultFilters={defaultFilters}
        filters={filters}
        setFilters={setFilters}
        count={querySummary.data?.listSize}
        currency={querySummary.data?.currency}
        mb="L"
      />

      {queryRows.isLoading && <WSLoader.Spinner size="S" />}

      {queryRows.data && queryRows.data.length === 0 && (
        <WSText.ParagraphSm color="gray500">
          No scheduled invoices found
        </WSText.ParagraphSm>
      )}

      <WSInfiniteScroll
        onLoad={() => {
          queryRows.fetchNextPage();
        }}
        loadMore={queryRows.data && queryRows.data.length > 0}
        endOfList={!queryRows.hasNextPage}
        loading={!!queryRows.isFetchingNextPage}
      >
        <TableInvoiceTemplates
          invoiceTemplates={queryRows.data || []}
          loading={queryRows.isLoading}
        />
      </WSInfiniteScroll>
    </WSPage>
  );
};
